import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/pdfs.svg'
import _imports_3 from '@/assets/deleteIcon.svg'
import _imports_4 from '@/assets/sortBy.svg'
import _imports_5 from '@/assets/arrowRight.svg'
import _imports_6 from '@/assets/cancel.svg'
import _imports_7 from '@/assets/Browse.svg'
import _imports_8 from '@/assets/warning.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "row w-full flex-shrink-0 flex mt-2"
}
const _hoisted_3 = { class: "w-7/12" }
const _hoisted_4 = { class: "w-full minheight" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 pb-3 px-5 pt-5 border-lightgrey flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_9 = {
  key: 1,
  class: "h-full min-h-0"
}
const _hoisted_10 = { class: "descriptionToggle overflow-y-auto" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "w-6/12" }
const _hoisted_14 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_15 = { class: "w-6/12" }
const _hoisted_16 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_17 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = { class: "mt-1 mb-3 text-sm" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_26 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_29 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_33 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_34 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_35 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_36 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_37 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_38 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_41 = { class: "border-b border-lightgrey flex flex-row" }
const _hoisted_42 = { class: "text-xs py-0.5 bg-white font-bold h-auto flex items-center my-1.5 header" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "flex flex-row w-50 mt-2 mb-2" }
const _hoisted_45 = { class: "w-50 border-t border-r border-b p-2 header border-lightgrey rounded-r-sm" }
const _hoisted_46 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_47 = {
  key: 0,
  class: "mt-1.5 text-xs"
}
const _hoisted_48 = {
  key: 1,
  class: "mt-1.5 text-xs"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "flex flex-row w-full pt-2" }
const _hoisted_51 = { class: "w-30 border-t border-r border-b p-2 header border-lightgrey" }
const _hoisted_52 = { class: "w-27 border-t border-r border-b p-2 header border-lightgrey w-23 rounded-r-sm" }
const _hoisted_53 = { class: "pl-20" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { class: "flex justify-between border-b border-lightgrey mt-2" }
const _hoisted_57 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_58 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_59 = { key: 3 }
const _hoisted_60 = { class: "border-b border-lightgrey" }
const _hoisted_61 = { class: "flex justify-between mt-2" }
const _hoisted_62 = { class: "flex gap-2" }
const _hoisted_63 = {
  key: 0,
  class: "flex mt-5 gap-4 flex-wrap"
}
const _hoisted_64 = { class: "pdf w-full rounded-sm" }
const _hoisted_65 = ["href"]
const _hoisted_66 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_67 = {
  key: 0,
  class: "text-xs ml-2"
}
const _hoisted_68 = {
  key: 1,
  class: "text-xs ml-1"
}
const _hoisted_69 = {
  key: 2,
  class: "ml-2 fontSize10PX font-semibold"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { key: 4 }
const _hoisted_72 = { class: "border-b border-lightgrey flex justify-between mt-2" }
const _hoisted_73 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_74 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_75 = { class: "comment-box w-full" }
const _hoisted_76 = { class: "my-5" }
const _hoisted_77 = {
  key: 0,
  class: "comments"
}
const _hoisted_78 = { class: "w-1/5" }
const _hoisted_79 = { class: "header" }
const _hoisted_80 = { class: "fontSize10PX" }
const _hoisted_81 = { class: "w-4/5 text-xs" }
const _hoisted_82 = { key: 5 }
const _hoisted_83 = { class: "border-b border-lightgrey" }
const _hoisted_84 = { class: "flex justify-between mt-2" }
const _hoisted_85 = {
  key: 0,
  class: ""
}
const _hoisted_86 = { class: "flex flex-row" }
const _hoisted_87 = { class: "border header border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_88 = { class: "flex flex-row" }
const _hoisted_89 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_90 = { class: "flex flex-row" }
const _hoisted_91 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_92 = { class: "flex flex-row" }
const _hoisted_93 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs" }
const _hoisted_94 = { class: "flex flex-row" }
const _hoisted_95 = { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }
const _hoisted_96 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md text-xs" }
const _hoisted_97 = { key: 6 }
const _hoisted_98 = { class: "border-b border-lightgrey" }
const _hoisted_99 = { class: "flex justify-between mt-2" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "flex flex-row mt-5" }
const _hoisted_102 = { class: "border-l border-t border-b border-lightgrey text-xs flex items-center w-27 p-2 header" }
const _hoisted_103 = { class: "border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md" }
const _hoisted_104 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_105 = { class: "flex flex-row" }
const _hoisted_106 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center" }
const _hoisted_107 = { class: "flex flex-row" }
const _hoisted_108 = { class: "border-b border-l text-xs flex items-center border-lightgrey w-27 p-2" }
const _hoisted_109 = { class: "border-r border-b border-l border-lightgrey text-xs flex items-center w-27 p-2" }
const _hoisted_110 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_111 = { class: "border-l border-r border-b header border-lightgrey w-77 p-2 h-14" }
const _hoisted_112 = {
  key: 0,
  class: "text-sm w-full h-[2.5rem] flex items-center justify-center"
}
const _hoisted_113 = {
  key: 1,
  class: "ml-2 mr-2"
}
const _hoisted_114 = { class: "progress-container" }
const _hoisted_115 = { class: "progress-indicator-count" }
const _hoisted_116 = { class: "flex flex-row" }
const _hoisted_117 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center rounded-br-md" }
const _hoisted_118 = { key: 1 }
const _hoisted_119 = { class: "flex flex-row mt-5" }
const _hoisted_120 = { class: "border-l border-t border-b border-lightgrey text-xs flex items-center w-27 p-2 header" }
const _hoisted_121 = { class: "flex flex-row" }
const _hoisted_122 = { class: "border-b border-l border-r border-lightgrey w-77 p-2" }
const _hoisted_123 = {
  key: 0,
  class: "border-b mt-3 border-lightgrey"
}
const _hoisted_124 = { class: "flex justify-between mt-2" }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { class: "flex flex-row mt-5" }
const _hoisted_127 = {
  key: 0,
  class: "border-t border-r border-b border-l border-lightgrey w-27 p-2"
}
const _hoisted_128 = {
  key: 1,
  class: "border-t border-r border-b border-l border-lightgrey w-27 p-2"
}
const _hoisted_129 = { class: "border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md" }
const _hoisted_130 = { class: "flex flex-row" }
const _hoisted_131 = { class: "border-r border-b border-l border-lightgrey w-77 p-2" }
const _hoisted_132 = { class: "flex flex-row" }
const _hoisted_133 = { class: "border-l border-lightgrey w-27 p-2" }
const _hoisted_134 = { class: "border-r border-l border-lightgrey w-27 p-2" }
const _hoisted_135 = { class: "flex flex-row" }
const _hoisted_136 = { class: "border header border-lightgrey w-77 p-2 h-14" }
const _hoisted_137 = { class: "ml-2 mr-2" }
const _hoisted_138 = { class: "progress-container" }
const _hoisted_139 = { class: "progress-indicator-count" }
const _hoisted_140 = { class: "flex flex-row" }
const _hoisted_141 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md" }
const _hoisted_142 = { key: 2 }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = { key: 3 }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 7 }
const _hoisted_147 = { class: "border-b border-lightgrey flex justify-between mt-2" }
const _hoisted_148 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_149 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_150 = { class: "flex" }
const _hoisted_151 = {
  key: 0,
  class: "initials cursor-pointer"
}
const _hoisted_152 = {
  key: 1,
  class: "initials cursor-pointer"
}
const _hoisted_153 = { class: "logContainer w-93" }
const _hoisted_154 = { class: "flex pt-1.5" }
const _hoisted_155 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_156 = {
  key: 1,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_157 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_158 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_159 = {
  key: 4,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_160 = {
  key: 5,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_161 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_162 = {
  key: 0,
  class: "flex"
}
const _hoisted_163 = { class: "text-xs w-88 ml-4" }
const _hoisted_164 = {
  key: 1,
  class: "flex flex-wrap items-center"
}
const _hoisted_165 = { class: "mx-2 text-xs" }
const _hoisted_166 = { class: "mx-2 text-xs" }
const _hoisted_167 = {
  key: 2,
  class: "flex"
}
const _hoisted_168 = { class: "mx-2 text-xs" }
const _hoisted_169 = { class: "mx-2 text-xs" }
const _hoisted_170 = {
  key: 3,
  class: "flex"
}
const _hoisted_171 = { class: "mx-2 text-xs" }
const _hoisted_172 = {
  key: 4,
  class: "flex mt-2"
}
const _hoisted_173 = { class: "mx-2 text-xs" }
const _hoisted_174 = {
  key: 5,
  class: "flex mt-2"
}
const _hoisted_175 = { class: "mx-2 text-xs" }
const _hoisted_176 = {
  key: 6,
  class: "flex mt-2"
}
const _hoisted_177 = { class: "mx-2 text-xs" }
const _hoisted_178 = {
  key: 7,
  class: "flex"
}
const _hoisted_179 = { class: "mx-2 text-xs" }
const _hoisted_180 = { class: "mx-2 text-xs" }
const _hoisted_181 = { class: "mx-2 text-xs" }
const _hoisted_182 = { class: "font-semibold text-xs shrink-0 whitespace-nowrap" }
const _hoisted_183 = { class: "mx-2 text-xs min-w-0 break-words" }
const _hoisted_184 = { class: "text-xs min-w-0 break-words" }
const _hoisted_185 = {
  key: 8,
  class: "flex"
}
const _hoisted_186 = { class: "mx-2 text-xs" }
const _hoisted_187 = {
  key: 9,
  class: "flex"
}
const _hoisted_188 = { class: "mx-2 text-xs" }
const _hoisted_189 = {
  key: 10,
  class: "flex"
}
const _hoisted_190 = { class: "mx-2 text-xs" }
const _hoisted_191 = {
  key: 11,
  class: "flex mt-2"
}
const _hoisted_192 = { class: "mx-2 text-xs" }
const _hoisted_193 = {
  key: 12,
  class: "flex"
}
const _hoisted_194 = { class: "mx-2 text-xs" }
const _hoisted_195 = {
  key: 13,
  class: "flex items-center"
}
const _hoisted_196 = { class: "flex ml-4" }
const _hoisted_197 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_198 = { class: "m-3" }
const _hoisted_199 = { key: 0 }
const _hoisted_200 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_201 = {
  key: 1,
  class: "pt-2 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_202 = {
  key: 0,
  class: "bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 mb-3"
}
const _hoisted_203 = { key: 1 }
const _hoisted_204 = { class: "mt-3" }
const _hoisted_205 = { key: 0 }
const _hoisted_206 = { key: 1 }
const _hoisted_207 = { class: "mt-2" }
const _hoisted_208 = { key: 2 }
const _hoisted_209 = { class: "mt-3" }
const _hoisted_210 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_211 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_212 = { class: "mt-3" }
const _hoisted_213 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_214 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_215 = { class: "mt-3" }
const _hoisted_216 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_217 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_218 = { class: "mt-3" }
const _hoisted_219 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_220 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_221 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_222 = { key: 3 }
const _hoisted_223 = { key: 4 }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = {
  key: 5,
  class: "mt-2 text-sm"
}
const _hoisted_226 = { class: "mt-3" }
const _hoisted_227 = { class: "mt-3" }
const _hoisted_228 = { key: 0 }
const _hoisted_229 = { key: 1 }
const _hoisted_230 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_231 = { class: "flex flex-col h-full" }
const _hoisted_232 = { class: "flex-1 overflow-auto" }
const _hoisted_233 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_234 = { class: "formcontainer flex flex-col" }
const _hoisted_235 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_236 = { class: "row flex flex-row w-full" }
const _hoisted_237 = { class: "w-1/2 pr-2" }
const _hoisted_238 = { class: "mt-2 text-sm inputboxstyling" }
const _hoisted_239 = { class: "w-1/2" }
const _hoisted_240 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_241 = { key: 0 }
const _hoisted_242 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_243 = { class: "w-1/2 pr-2" }
const _hoisted_244 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_245 = { key: 0 }
const _hoisted_246 = {
  key: 0,
  class: "w-1/2 min-w-0"
}
const _hoisted_247 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_248 = { key: 0 }
const _hoisted_249 = {
  key: 1,
  class: "w-1/2 min-w-0"
}
const _hoisted_250 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_251 = { key: 0 }
const _hoisted_252 = { class: "w-full upperspacing" }
const _hoisted_253 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_254 = {
  key: 0,
  class: "error-text"
}
const _hoisted_255 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_256 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_257 = ["disabled"]
const _hoisted_258 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_259 = { class: "flex flex-col h-full" }
const _hoisted_260 = { class: "flex-1 overflow-auto" }
const _hoisted_261 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_262 = { class: "formcontainer flex flex-col" }
const _hoisted_263 = { class: "row flex flex-row w-full" }
const _hoisted_264 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_265 = { class: "w-1/2 pr-2" }
const _hoisted_266 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_267 = {
  key: 0,
  class: "error-text"
}
const _hoisted_268 = {
  key: 1,
  class: "error-text"
}
const _hoisted_269 = { class: "w-1/2 pr-2" }
const _hoisted_270 = ["disabled"]
const _hoisted_271 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_272 = {
  key: 0,
  class: "error-text"
}
const _hoisted_273 = { class: "row flex flex-row w-full" }
const _hoisted_274 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_275 = { class: "w-1/2 pr-2" }
const _hoisted_276 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_277 = {
  key: 0,
  class: "error-text"
}
const _hoisted_278 = { class: "w-full upperspacing" }
const _hoisted_279 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_280 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_281 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_282 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_283 = ["disabled"]
const _hoisted_284 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_285 = { class: "kpi-result-popup flex flex-col h-full min-w-0 max-w-full" }
const _hoisted_286 = { class: "flex-1 min-w-0 overflow-x-hidden overflow-y-auto" }
const _hoisted_287 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_288 = { class: "formcontainer flex flex-col min-w-0" }
const _hoisted_289 = { class: "row flex flex-row w-full min-w-0 upperspacing" }
const _hoisted_290 = { class: "row flex flex-row w-full min-w-0" }
const _hoisted_291 = { class: "w-full pr-2 min-w-0" }
const _hoisted_292 = {
  key: 0,
  class: "kpi-title-select-wrap"
}
const _hoisted_293 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_294 = {
  key: 0,
  class: "error-text"
}
const _hoisted_295 = { class: "row flex flex-row w-full" }
const _hoisted_296 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_297 = { class: "w-1/2 pr-2" }
const _hoisted_298 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_299 = {
  key: 0,
  class: "error-text"
}
const _hoisted_300 = { class: "w-1/2 pr-2" }
const _hoisted_301 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_302 = {
  key: 0,
  class: "error-text"
}
const _hoisted_303 = {
  key: 1,
  class: "error-text"
}
const _hoisted_304 = { class: "row flex flex-row w-full" }
const _hoisted_305 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_306 = { class: "w-1/2 pr-2" }
const _hoisted_307 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_308 = {
  key: 0,
  class: "error-text"
}
const _hoisted_309 = { class: "w-full upperspacing" }
const _hoisted_310 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_311 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_312 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_313 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_314 = ["disabled"]
const _hoisted_315 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_316 = { class: "relative w-full max-w-xl" }
const _hoisted_317 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_318 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_319 = { class: "flex flex-col h-full" }
const _hoisted_320 = { class: "flex-1 overflow-auto" }
const _hoisted_321 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_322 = { class: "formcontainer flex flex-col" }
const _hoisted_323 = { class: "row flex flex-col mt-2" }
const _hoisted_324 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_325 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_326 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_327 = { class: "pt-3" }
const _hoisted_328 = {
  for: "upload",
  class: "cursor-pointer"
}
const _hoisted_329 = {
  key: 0,
  class: "text-sm text-mediumGrey heightForDiv"
}
const _hoisted_330 = {
  key: 1,
  class: "text-sm heightForDiv"
}
const _hoisted_331 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_332 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_333 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_334 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_335 = ["disabled"]
const _hoisted_336 = {
  key: 6,
  class: "evidence-delete-confirm"
}
const _hoisted_337 = { class: "evidence-delete-dialog" }
const _hoisted_338 = { class: "evidence-delete-dialog-actions" }
const _hoisted_339 = {
  key: 7,
  class: "link-existing-confirm"
}
const _hoisted_340 = { class: "link-existing-dialog" }
const _hoisted_341 = { class: "link-existing-tables" }
const _hoisted_342 = { class: "link-existing-section-row" }
const _hoisted_343 = { class: "link-existing-section" }
const _hoisted_344 = { class: "link-existing-table" }
const _hoisted_345 = { class: "flex table-header-label-wrap" }
const _hoisted_346 = { class: "flex table-header-label-wrap" }
const _hoisted_347 = { class: "flex table-header-label-wrap" }
const _hoisted_348 = { class: "flex table-header-label-wrap" }
const _hoisted_349 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_350 = { key: 0 }
const _hoisted_351 = { class: "link-existing-col-check" }
const _hoisted_352 = ["checked", "onChange"]
const _hoisted_353 = ["title"]
const _hoisted_354 = { key: 1 }
const _hoisted_355 = { class: "link-existing-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", {
              class: _normalizeClass(["title", _ctx.titleLength > 40? 'table-ellipsis':''])
            }, _toDisplayString(_ctx.presentTaskObject.controlTitle), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Tabs, {
              value: _ctx.selectedTabIndex,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
              scrollable: "",
              class: "w-80 pr-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_TabList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_Tab, {
                          key: tab.id,
                          value: tab.id,
                          onClick: ($event: any) => (_ctx.toggleTabs(tab))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_TabPanel, {
                        key: tab.id,
                        value: tab.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.tabDataLoading == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_dots_loader)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  (tab.id == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", null, [
                                          _cache[71] || (_cache[71] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                              _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Control Info")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                              _cache[69] || (_cache[69] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "CID", -1)),
                                              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined|| _ctx.presentTaskObject.clientUniqueId!='' ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                              _cache[70] || (_cache[70] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "Frequency", -1)),
                                              ((_ctx.presentTaskObject.controlFrequency))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.dbFrequency.find((l) => l.value == _ctx.presentTaskObject.controlFrequency)?.key||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_17, "N/A"))
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[72] || (_cache[72] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.presentTaskObject?.controlTitle||'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_21, [
                                            _cache[73] || (_cache[73] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.presentTaskObject?.controlType||'N/A'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _cache[74] || (_cache[74] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Class", -1)),
                                            ((_ctx.presentTaskObject?.controlClass))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.presentTaskObject?.controlClass||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_26, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _cache[75] || (_cache[75] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Family", -1)),
                                            ((_ctx.presentTaskObject?.controlFamily))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.presentTaskObject?.controlFamily||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_29, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _cache[76] || (_cache[76] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                            (_ctx.presentTaskObject?.controlPriority && typeof _ctx.presentTaskObject?.controlPriority === 'number')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentTaskObject?.controlPriority)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentTaskObject?.controlPriority)])
                                                  }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentTaskObject?.controlPriority)), 3)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_32, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[77] || (_cache[77] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                          ((_ctx.presentTaskObject?.Description))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.presentTaskObject?.Description||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_34, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                          ((_ctx.presentTaskObject?.controlPolicies))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.presentTaskObject?.controlPolicies||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_36, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[79] || (_cache[79] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                          ((_ctx.presentTaskObject?.controlGuidance))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.presentTaskObject?.controlGuidance||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_38, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[80] || (_cache[80] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                          ((_ctx.presentTaskObject?.controlMaintenanceTask))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.presentTaskObject?.controlMaintenanceTask||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_40, "N/A"))
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsArray, (control) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: control.framework,
                                            class: "pt-2 pb-3"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(control.controlsDetailsArray, (detail) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: detail.controlNumber
                                              }, [
                                                _createElementVNode("div", _hoisted_41, [
                                                  _createElementVNode("p", _hoisted_42, _toDisplayString(control.framework), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_43, [
                                                  _createElementVNode("div", _hoisted_44, [
                                                    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "w-50 border-t border-l border-r border-b p-2 header border-lightgrey rounded-l-sm" }, [
                                                      _createElementVNode("label", { class: "controllabel" }, "Number")
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_45, [
                                                      _createElementVNode("div", _hoisted_46, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass([_ctx.getBorder(), 'text-xs px-2 py-0.5 bg-white font-bold h-auto flex items-center'])
                                                        }, _toDisplayString(detail.controlNumber), 3)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _cache[82] || (_cache[82] = _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                  _createElementVNode("p", { class: "my-1.5 header" }, "Description")
                                                ], -1)),
                                                (detail.description == null || detail.description == undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString('N/A')))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(detail.description), 1))
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128)),
                                        (_ctx.kpisObject && _ctx.kpisObject.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _cache[85] || (_cache[85] = _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                _createElementVNode("p", { class: "my-1.5 header" }, "KPI")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_50, [
                                                _cache[83] || (_cache[83] = _createElementVNode("div", { class: "border-l border-t border-r w-20 border-b p-2 header border-lightgrey rounded-l-sm" }, "Name", -1)),
                                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.kpisObject[0].description != undefined ? _ctx.kpisObject[0].description : 'N/A'), 1),
                                                _cache[84] || (_cache[84] = _createElementVNode("div", { class: "controllabel border-t border-r border-b p-2 header border-lightgrey w-23" }, "Weightage (%)", -1)),
                                                _createElementVNode("div", _hoisted_52, [
                                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.kpisObject[0].weightage != undefined ? _ctx.kpisObject[0].weightage : 'N/A'), 1)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, _cache[86] || (_cache[86] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                            _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Documents which are related to the controls")
                                          ])
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  (tab.id==3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                          _cache[88] || (_cache[88] = _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1.5 header" }, "Related Tasks")
                                          ], -1)),
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["flex justify-between items-center", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none': 'filterButton flex justify-center ']),
                                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                                          }, [
                                            (_ctx.tableRow.length == 0)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_58)),
                                            _cache[87] || (_cache[87] = _createTextVNode(" Filters "))
                                          ], 2)
                                        ]),
                                        _createVNode(_component_tableData, {
                                          tableRowData: _ctx.tableRow,
                                          headersData: _ctx.Headers
                                        }, null, 8, ["tableRowData", "headersData"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                              _cache[89] || (_cache[89] = _createElementVNode("div", { class: "my-1.5 header" }, "Files", -1)),
                                              _createElementVNode("div", _hoisted_62, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                  class: _normalizeClass(_ctx.isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center')
                                                }, "Link Existing", 2),
                                                _createElementVNode("button", {
                                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFilePicker && _ctx.openFilePicker(...args))),
                                                  class: _normalizeClass(_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||  _ctx.TaskDetailsDropDown.taskStatus == 10401 ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center'),
                                                  for: "upload"
                                                }, "Attach", 2)
                                              ])
                                            ])
                                          ]),
                                          (Object.keys(_ctx.presentTaskObject).includes('files'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.files, (doc) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: doc }, [
                                                    _createElementVNode("div", _hoisted_64, [
                                                      _createElementVNode("a", {
                                                        href: doc.url,
                                                        class: "flex w-full flex-row items-center"
                                                      }, [
                                                        _cache[91] || (_cache[91] = _createElementVNode("img", {
                                                          src: _imports_2,
                                                          alt: ""
                                                        }, null, -1)),
                                                        _createElementVNode("div", _hoisted_66, [
                                                          (Object.keys(doc).includes('filename'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(doc.filename), 1))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(doc.name), 1)),
                                                          (doc.taskId)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(doc.taskId), 1))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("button", {
                                                          type: "button",
                                                          class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                          onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentTaskObject.files.indexOf(doc))), ["stop","prevent"])
                                                        }, _cache[90] || (_cache[90] = [
                                                          _createElementVNode("img", {
                                                            src: _imports_3,
                                                            alt: "Delete"
                                                          }, null, -1)
                                                        ]), 10, _hoisted_70)
                                                      ], 8, _hoisted_65)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_72, [
                                            _cache[94] || (_cache[94] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Comments")
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_73, [
                                                _createElementVNode("div", _hoisted_74, [
                                                  (_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(["filterButton flex", Object.keys(this.presentTaskObject).includes('comments') && this.presentTaskObject.comments.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[92] || (_cache[92] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ]), 2))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.oldComments)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton flex",
                                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortComments()))
                                                      }, _cache[93] || (_cache[93] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_75, [
                                              _createElementVNode("div", _hoisted_76, [
                                                (_ctx.TaskDetailsDropDown.taskStatus!=10403 && _ctx.TaskDetailsDropDown.taskStatus!=10418 && _ctx.TaskDetailsDropDown.taskStatus!=10417)
                                                  ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                      key: 0,
                                                      taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                    }, null, 8, ["taskStatusCode"]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (Object.keys(_ctx.presentTaskObject).includes('comments'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.comments, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                      key: index
                                                    }, [
                                                      _createElementVNode("div", _hoisted_78, [
                                                        _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.getPersonName(obj.createdBy)), 1),
                                                        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.formatTime( obj.createdAt )), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_81, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: obj.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("div", _hoisted_84, [
                                              _cache[95] || (_cache[95] = _createElementVNode("div", { class: "my-1.5 header" }, "Findings", -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showpopupOnAdd())),
                                                  class: _normalizeClass((_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418) || _ctx.presentTaskObject.reviewer != _ctx.userInfo._id || _ctx.TaskDetailsDropDown.taskStatus == 10401 ? 'btndisabled pointer-events-none ': 'filterButton flex justify-center')
                                                }, "Add Findings", 2)
                                              ])
                                            ])
                                          ]),
                                          (Object.keys(_ctx.presentTaskObject).includes('findings'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingsForCompliance, (obj, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: "w-full h-auto mt-5"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_86, [
                                                      _cache[96] || (_cache[96] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Finding ID", -1)),
                                                      _createElementVNode("div", _hoisted_87, _toDisplayString(obj.findingId?.toUpperCase()), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_88, [
                                                      _cache[97] || (_cache[97] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding", -1)),
                                                      _createElementVNode("div", _hoisted_89, _toDisplayString(obj.finding), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_90, [
                                                      _cache[98] || (_cache[98] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Evidence", -1)),
                                                      _createElementVNode("div", _hoisted_91, _toDisplayString(obj.findingEvidence), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_92, [
                                                      _cache[99] || (_cache[99] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Related To", -1)),
                                                      _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.getFindingRelatedToDisplay(obj.findingRelatedTo)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_94, [
                                                      _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.getFindingLinkFieldLabel(obj)), 1),
                                                      _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.getFindingLinkDisplay(obj)), 1)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==7)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_98, [
                                            _createElementVNode("div", _hoisted_99, [
                                              _cache[100] || (_cache[100] = _createElementVNode("div", { class: "my-1.5 header" }, "Control Result", -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showpopupOnAddForResult('addresult'))),
                                                  class: _normalizeClass(_ctx.conditionForResultBtn() || (!_ctx.presentTaskObject.kpis && (Object.keys(_ctx.presentTaskObject).includes('controlResults') && _ctx.presentTaskObject.controlResults?.length != 0) || _ctx.presentTaskObject.reviewer != _ctx.userInfo._id || _ctx.presentTaskObject?.controlResults?.length==1) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center')
                                                }, "Add Result", 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            (_ctx.controlResultsForCompliance.length != 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlResultsForCompliance, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                      _createElementVNode("div", _hoisted_101, [
                                                        _cache[101] || (_cache[101] = _createElementVNode("div", { class: "border-l border-t border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Control ID ", -1)),
                                                        _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1),
                                                        _cache[102] || (_cache[102] = _createElementVNode("div", { class: "border-l border-t border-b p-2 header w-23 border-lightgrey" }, "Risk Severity ", -1)),
                                                        _createElementVNode("div", _hoisted_103, [
                                                          (obj.severity === 'N/A')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, "N/A"))
                                                            : (_openBlock(), _createElementBlock("div", {
                                                                key: 1,
                                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(obj.severity)])
                                                              }, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(_ctx.colorRiskText(obj.severity))
                                                                }, _toDisplayString(_ctx.getSeverityLabel(obj.severity)), 3)
                                                              ], 2))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_105, [
                                                        _cache[103] || (_cache[103] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Title", -1)),
                                                        _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.presentTaskObject.controlTitle), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_107, [
                                                        _cache[104] || (_cache[104] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Population ", -1)),
                                                        _createElementVNode("div", _hoisted_108, _toDisplayString(obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation), 1),
                                                        _cache[105] || (_cache[105] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Compliant ", -1)),
                                                        _createElementVNode("div", _hoisted_109, _toDisplayString(obj.actualOutput == null || obj.actualOutput === '' ? 'N/A' : obj.actualOutput), 1)
                                                      ]),
                                                      (obj.resultfor == 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                            _cache[106] || (_cache[106] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Performance Analysis", -1)),
                                                            _createElementVNode("div", _hoisted_111, [
                                                              (obj.controlResultValue == null || obj.controlResultValue === '')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, "N/A"))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                                    _createElementVNode("div", _hoisted_114, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["progress-bar", _ctx.getPerformanceBg(obj.controlResultValue)]),
                                                                        style: _normalizeStyle({ width: `${obj.controlResultValue}%` })
                                                                      }, null, 6)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_115, [
                                                                      (obj.controlResultValue >= 50)
                                                                        ? (_openBlock(), _createElementBlock("p", {
                                                                            key: 0,
                                                                            class: "indicator mt-1",
                                                                            style: _normalizeStyle({left: `calc(${obj.controlResultValue}% - 20px)`})
                                                                          }, _toDisplayString(obj.controlResultValue) + "%", 5))
                                                                        : (_openBlock(), _createElementBlock("p", {
                                                                            key: 1,
                                                                            class: "indicator mt-1",
                                                                            style: _normalizeStyle({left: `calc(${obj.controlResultValue}%)`})
                                                                          }, _toDisplayString(obj.controlResultValue) + "%", 5))
                                                                    ])
                                                                  ]))
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_116, [
                                                        _cache[107] || (_cache[107] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }, "Comments", -1)),
                                                        _createElementVNode("div", _hoisted_117, _toDisplayString(obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments), 1)
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : (_ctx.controlResultsForCompliance.length <= 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("div", _hoisted_119, [
                                                        _cache[108] || (_cache[108] = _createElementVNode("div", { class: "border-l border-t border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Control ID ", -1)),
                                                        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.presentTaskObject.clientUniqueId != undefined ? _ctx.presentTaskObject.clientUniqueId : 'N/A'), 1),
                                                        _cache[109] || (_cache[109] = _createElementVNode("div", { class: "border-l border-t border-b p-2 header w-23 border-lightgrey" }, "Risk Severity ", -1)),
                                                        _cache[110] || (_cache[110] = _createElementVNode("div", { class: "border-l border-t border-b border-r border-lightgrey w-27 p-2 rounded-tr-md" }, null, -1))
                                                      ]),
                                                      _createElementVNode("div", _hoisted_121, [
                                                        _cache[111] || (_cache[111] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Title", -1)),
                                                        _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.presentTaskObject.controlTitle), 1)
                                                      ]),
                                                      _cache[112] || (_cache[112] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Population "),
                                                        _createElementVNode("div", { class: "border-b border-l border-lightgrey w-27 p-2" }),
                                                        _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Compliant "),
                                                        _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-27 p-2" })
                                                      ], -1)),
                                                      _cache[113] || (_cache[113] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Performance Analysis"),
                                                        _createElementVNode("div", { class: "border-l border-r border-b header border-lightgrey w-77 p-2 h-14" }, [
                                                          _createElementVNode("div", { class: "ml-2 mr-2" }, [
                                                            _createElementVNode("div", { class: "progress-container" }, [
                                                              _createElementVNode("div", { class: "progress-bar" })
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                              _createElementVNode("div", { class: "progress-indicator-count" }, [
                                                                _createElementVNode("p", {
                                                                  class: "indicator",
                                                                  style: {left: `calc(${0}%)`}
                                                                }, _toDisplayString(0) + "%")
                                                              ])
                                                            ])
                                                          ])
                                                        ])
                                                      ], -1)),
                                                      _cache[114] || (_cache[114] = _createElementVNode("div", { class: "flex flex-row" }, [
                                                        _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }, "Comments"),
                                                        _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs rounded-br-md" })
                                                      ], -1))
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                          ]),
                                          (_ctx.presentTaskObject.kpis)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                _createElementVNode("div", _hoisted_124, [
                                                  _cache[115] || (_cache[115] = _createElementVNode("div", { class: "my-1.5 header" }, "KPI Result", -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("button", {
                                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showpopupOnAddForResult('addkpi'))),
                                                      class: _normalizeClass(_ctx.conditionForResultBtn() || (!_ctx.presentTaskObject.kpis && (Object.keys(_ctx.presentTaskObject).includes('controlResults') && _ctx.presentTaskObject.controlResults.length != 0) || _ctx.presentTaskObject.reviewer != _ctx.userInfo._id)||(_ctx.resultArray.length==0)||((_ctx.presentTaskObject.results)?.length == _ctx.presentTaskObject.kpis.length)? 'btndisabled pointer-events-none': 'filterButton flex justify-center taskEditButtons')
                                                    }, "Add Result", 2)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.resultsForCompliance.length != 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.results, (obj, index) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                    _createElementVNode("div", _hoisted_126, [
                                                      _cache[116] || (_cache[116] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "KPI ID", -1)),
                                                      (obj.controlorKpi != '')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(_ctx.presentTaskObject.kpis.find((kpi)=>kpi._id == obj.controlorKpi)?.kpi_id ||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_128)),
                                                      _cache[117] || (_cache[117] = _createElementVNode("div", { class: "border-t border-b p-2 header w-23 border-lightgrey" }, "Risk Severity", -1)),
                                                      _createElementVNode("div", _hoisted_129, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(obj.severity)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorRiskText(obj.severity))
                                                          }, _toDisplayString(_ctx.getSeverityLabel(obj.severity)), 3)
                                                        ], 2)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_130, [
                                                      _cache[118] || (_cache[118] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "KPI Name", -1)),
                                                      _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.presentTaskObject.kpis.find((kpi)=>kpi._id == obj.controlorKpi)?.description), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_132, [
                                                      _cache[119] || (_cache[119] = _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Compliant ", -1)),
                                                      _createElementVNode("div", _hoisted_133, _toDisplayString(obj.actualOutput), 1),
                                                      _cache[120] || (_cache[120] = _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Population ", -1)),
                                                      _createElementVNode("div", _hoisted_134, _toDisplayString(obj.totalPopulation == null || obj.totalPopulation === '' ? 'N/A' : obj.totalPopulation), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_135, [
                                                      _cache[121] || (_cache[121] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey" }, "Performance Analysis", -1)),
                                                      _createElementVNode("div", _hoisted_136, [
                                                        _createElementVNode("div", _hoisted_137, [
                                                          _createElementVNode("div", _hoisted_138, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["progress-bar", _ctx.getPerformanceBg(obj.kpiProgress)]),
                                                              style: _normalizeStyle({ width: `${obj.kpiProgress}%` })
                                                            }, null, 6)
                                                          ]),
                                                          _createElementVNode("div", null, [
                                                            _createElementVNode("div", _hoisted_139, [
                                                              (obj.kpiProgress >= 50)
                                                                ? (_openBlock(), _createElementBlock("p", {
                                                                    key: 0,
                                                                    class: "indicator",
                                                                    style: _normalizeStyle({left: `calc(${obj.kpiProgress}% - 20px)`})
                                                                  }, _toDisplayString(obj.kpiProgress) + "%", 5))
                                                                : (_openBlock(), _createElementBlock("p", {
                                                                    key: 1,
                                                                    class: "indicator",
                                                                    style: _normalizeStyle({left: `calc(${obj.kpiProgress}%)`})
                                                                  }, _toDisplayString(obj.kpiProgress) + "%", 5))
                                                            ])
                                                          ])
                                                        ])
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_140, [
                                                      _cache[122] || (_cache[122] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }, "Comments", -1)),
                                                      _createElementVNode("div", _hoisted_141, _toDisplayString(obj.comments == null || obj.comments === '' ? 'N/A' : obj.comments), 1)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : (_ctx.resultsForCompliance.length == 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentTaskObject.kpis, (i) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                                                      ((_ctx.presentTaskObject.kpis != null || _ctx.presentTaskObject.kpis != undefined) && (_ctx.presentTaskObject.kpis.length > 0))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_143, _cache[123] || (_cache[123] = [
                                                            _createElementVNode("div", { class: "flex flex-row mt-5" }, [
                                                              _createElementVNode("div", { class: "border-t border-l p-2 header w-23 border-lightgrey rounded-tl-md" }, "KPI ID"),
                                                              _createElementVNode("div", { class: "border-t border-l border-lightgrey w-27 p-2" }),
                                                              _createElementVNode("div", { class: "border-t border-l p-2 header w-23 border-lightgrey" }, "Risk Severity"),
                                                              _createElementVNode("div", { class: "border-t border-r border-l border-lightgrey w-27 p-2 rounded-tr-md" })
                                                            ], -1),
                                                            _createElementVNode("div", { class: "flex flex-row" }, [
                                                              _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey" }, "KPI Name"),
                                                              _createElementVNode("div", { class: "border-t border-r border-b border-l border-lightgrey w-77 p-2" })
                                                            ], -1),
                                                            _createElementVNode("div", { class: "flex flex-row" }, [
                                                              _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Compliant "),
                                                              _createElementVNode("div", { class: "border-l border-lightgrey w-27 p-2" }),
                                                              _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Population "),
                                                              _createElementVNode("div", { class: "border-r border-l border-lightgrey w-27 p-2" })
                                                            ], -1),
                                                            _createElementVNode("div", { class: "flex flex-row h-14" }, [
                                                              _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey" }, "Performance Analysis"),
                                                              _createElementVNode("div", { class: "border header border-lightgrey w-77 p-2 h-14" }, [
                                                                _createElementVNode("div", { class: "ml-2 mr-2" }, [
                                                                  _createElementVNode("div", { class: "progress-container" }, [
                                                                    _createElementVNode("div", { class: "progress-bar" })
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createElementVNode("div", { class: "progress-indicator-count" }, [
                                                                      _createElementVNode("p", {
                                                                        class: "indicator",
                                                                        style: {left: `calc(${0}%)`}
                                                                      }, _toDisplayString(0) + "%")
                                                                    ])
                                                                  ])
                                                                ])
                                                              ])
                                                            ], -1),
                                                            _createElementVNode("div", { class: "flex flex-row" }, [
                                                              _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }, "Comments"),
                                                              _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md" })
                                                            ], -1)
                                                          ])))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true),
                                          (_ctx.presentTaskObject.results)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                                (_ctx.presentTaskObject.kpis.length != _ctx.presentTaskObject.results.length)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.presentTaskObject.kpis.length - _ctx.presentTaskObject.results.length), (index) => {
                                                        return (_openBlock(), _createElementBlock("div", { key: index }, _cache[124] || (_cache[124] = [
                                                          _createElementVNode("div", { class: "flex flex-row mt-5" }, [
                                                            _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "KPI ID"),
                                                            _createElementVNode("div", { class: "border-t border-r border-b border-l border-lightgrey w-27 p-2" }),
                                                            _createElementVNode("div", { class: "border-t border-b p-2 header w-23 border-lightgrey" }, "Risk Severity"),
                                                            _createElementVNode("div", { class: "border-t border-b border-l border-r border-lightgrey w-27 p-2 rounded-tr-md" })
                                                          ], -1),
                                                          _createElementVNode("div", { class: "flex flex-row" }, [
                                                            _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "KPI Name"),
                                                            _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-77 p-2" })
                                                          ], -1),
                                                          _createElementVNode("div", { class: "flex flex-row" }, [
                                                            _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Compliant "),
                                                            _createElementVNode("div", { class: "border-l border-lightgrey w-27 p-2" }),
                                                            _createElementVNode("div", { class: "border-l p-2 header w-23 border-lightgrey" }, "Population "),
                                                            _createElementVNode("div", { class: "border-r border-l border-lightgrey w-27 p-2" })
                                                          ], -1),
                                                          _createElementVNode("div", { class: "flex flex-row" }, [
                                                            _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey" }, "Performance Analysis"),
                                                            _createElementVNode("div", { class: "border header border-lightgrey w-77 p-2 h-14" }, [
                                                              _createElementVNode("div", { class: "ml-2 mr-2" }, [
                                                                _createElementVNode("div", { class: "progress-container" }, [
                                                                  _createElementVNode("div", { class: "progress-bar" })
                                                                ]),
                                                                _createElementVNode("div", { class: "progress-indicator-count" }, [
                                                                  _createElementVNode("p", {
                                                                    class: "indicator",
                                                                    style: {left: `calc(${0}%)`}
                                                                  }, _toDisplayString(0) + "%")
                                                                ])
                                                              ])
                                                            ])
                                                          ], -1),
                                                          _createElementVNode("div", { class: "flex flex-row" }, [
                                                            _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md" }, "Comments"),
                                                            _createElementVNode("div", { class: "border-r border-b border-l border-lightgrey w-77 p-2 rounded-br-md" })
                                                          ], -1)
                                                        ])))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id==8)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_147, [
                                            _cache[127] || (_cache[127] = _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-1.5 header" }, "Work History")
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_148, [
                                                _createElementVNode("div", _hoisted_149, [
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(["filterButton flex", Object.keys(this.workLogObject).includes('taskHistory') && this.workLogObject.taskHistory.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[125] || (_cache[125] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ]), 2))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton flex",
                                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[126] || (_cache[126] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_4,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: work,
                                              class: "bg-white py-4 border-lightgrey border-b w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_150, [
                                                (Object.keys(work).includes('createdBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(work.createdBy))), 1))
                                                  : _createCommentVNode("", true),
                                                (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(work.updatedBy))), 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_153, [
                                                  _createElementVNode("div", _hoisted_154, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_155, _toDisplayString(_ctx.getPersonName(work.createdBy)), 1))
                                                      : (Object.keys(work).includes('updatedBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_156, _toDisplayString(_ctx.getPersonName(work.updatedBy)), 1))
                                                        : _createCommentVNode("", true),
                                                    (work.actionEntity == 10301)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_157, _toDisplayString('Created the Task on')))
                                                      : (work.actionEntity == 10302)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_158, _toDisplayString('Updated the Task on')))
                                                        : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('createdAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_159, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_160, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (work.additionalInfo != null && Object.keys(work).includes('additionalInfo'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                                        (Object.keys(work.additionalInfo).includes('comment'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                                              _cache[128] || (_cache[128] = _createElementVNode("p", { class: "font-semibold text-xs w-12" }, _toDisplayString('Comment:'), -1)),
                                                              _createElementVNode("div", _hoisted_163, [
                                                                _createVNode(_component_safeHtml, {
                                                                  content: work.additionalInfo.comment
                                                                }, null, 8, ["content"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('actualOutput'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                                              _cache[130] || (_cache[130] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs pr-2" }, _toDisplayString('Added the Result -'), -1)),
                                                              _cache[131] || (_cache[131] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Compliant (A) :'), -1)),
                                                              _createElementVNode("p", _hoisted_165, _toDisplayString(work.additionalInfo.actualOutput), 1),
                                                              _cache[132] || (_cache[132] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Population (B) :'), -1)),
                                                              _createElementVNode("p", _hoisted_166, _toDisplayString(work.additionalInfo.totalPopulation), 1),
                                                              (work.additionalInfo.riskSeverity != null && work.additionalInfo.riskSeverity !== '')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[129] || (_cache[129] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Risk Severity :'), -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(work.additionalInfo.riskSeverity)])
                                                                    }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(_ctx.colorRiskText(work.additionalInfo.riskSeverity))
                                                                      }, _toDisplayString(_ctx.getSeverityLabel(work.additionalInfo.riskSeverity)), 3)
                                                                    ], 2)
                                                                  ], 64))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('updatedActualOutput'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                              _cache[135] || (_cache[135] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs pr-2" }, _toDisplayString('Updated the Result -'), -1)),
                                                              (!(work.additionalInfo.changes && work.additionalInfo.changes.length))
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[133] || (_cache[133] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Compliant (A) :'), -1)),
                                                                    _createElementVNode("p", _hoisted_168, _toDisplayString(work.additionalInfo.updatedActualOutput), 1),
                                                                    _cache[134] || (_cache[134] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Population (B) :'), -1)),
                                                                    _createElementVNode("p", _hoisted_169, _toDisplayString(work.additionalInfo.totalPopulation), 1)
                                                                  ], 64))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('findingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                                              _cache[136] || (_cache[136] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Added the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_171, _toDisplayString(work.additionalInfo.findingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('findingRelatedToLabel'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                                              _cache[137] || (_cache[137] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Related To -'), -1)),
                                                              _createElementVNode("p", _hoisted_173, _toDisplayString(work.additionalInfo.findingRelatedToLabel), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('controlTitle') && work.additionalInfo.controlTitle)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                              _cache[138] || (_cache[138] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Control -'), -1)),
                                                              _createElementVNode("p", _hoisted_175, _toDisplayString(work.additionalInfo.controlTitle), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('kpiName') && work.additionalInfo.kpiName)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                                              _cache[139] || (_cache[139] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('KPI -'), -1)),
                                                              _createElementVNode("p", _hoisted_177, _toDisplayString(work.additionalInfo.kpiName), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('updatedFindingId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                                              _cache[140] || (_cache[140] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Updated the finding -'), -1)),
                                                              _createElementVNode("p", _hoisted_179, _toDisplayString(work.additionalInfo.updatedFindingId), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.addedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'added-' + file
                                                          }, [
                                                            _cache[141] || (_cache[141] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Attached -'), -1)),
                                                            _createElementVNode("p", _hoisted_180, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.removedAttachments || []), (file) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex mt-2",
                                                            key: 'removed-' + file
                                                          }, [
                                                            _cache[142] || (_cache[142] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Removed the attachment -'), -1)),
                                                            _createElementVNode("p", _hoisted_181, _toDisplayString(file), 1)
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((work.additionalInfo.changes || []), (change) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "flex items-center mt-2",
                                                            key: change.field
                                                          }, [
                                                            _createElementVNode("p", _hoisted_182, _toDisplayString(change.field), 1),
                                                            (change.field === 'Risk Severity')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(change.previous)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.colorRiskText(change.previous))
                                                                    }, _toDisplayString(_ctx.getSeverityLabel(change.previous)), 3)
                                                                  ], 2),
                                                                  _cache[143] || (_cache[143] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                    _createElementVNode("img", {
                                                                      src: _imports_5,
                                                                      class: "shrink-0"
                                                                    })
                                                                  ], -1)),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(change.updated)])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.colorRiskText(change.updated))
                                                                    }, _toDisplayString(_ctx.getSeverityLabel(change.updated)), 3)
                                                                  ], 2)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createElementVNode("p", _hoisted_183, _toDisplayString(_ctx.formatResultHistoryValue(change.field, change.previous)), 1),
                                                                  _cache[144] || (_cache[144] = _createElementVNode("div", { class: "mx-2 flex items-center shrink-0" }, [
                                                                    _createElementVNode("img", {
                                                                      src: _imports_5,
                                                                      class: "shrink-0"
                                                                    })
                                                                  ], -1)),
                                                                  _createElementVNode("p", _hoisted_184, _toDisplayString(_ctx.formatResultHistoryValue(change.field, change.updated)), 1)
                                                                ], 64))
                                                          ]))
                                                        }), 128)),
                                                        (Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                              _cache[145] || (_cache[145] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_186, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.removed)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                                              _cache[146] || (_cache[146] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Deleted the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_188, _toDisplayString(work.additionalInfo.evidence), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                                              _cache[147] || (_cache[147] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_190, _toDisplayString(work.additionalInfo.linkedEvidenceTitles), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                                              _cache[148] || (_cache[148] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_192, _toDisplayString(work.additionalInfo.linkedEvidenceDates), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('assignee'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                              _cache[149] || (_cache[149] = _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Assigned the task to -'), -1)),
                                                              _createElementVNode("p", _hoisted_194, _toDisplayString(_ctx.getPersonName(work.additionalInfo.assignee)), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                              _cache[151] || (_cache[151] = _createElementVNode("div", null, [
                                                                _createElementVNode("p", { class: "font-semibold cursor-pointer text-xs" }, _toDisplayString('Updated The Status :'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_196, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorComplianceBg(work.additionalInfo.previousStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorComplianceText(work.additionalInfo.previousStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                ], 2),
                                                                _cache[150] || (_cache[150] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                  _createElementVNode("img", { src: _imports_5 })
                                                                ], -1)),
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorComplianceBg(work.additionalInfo.updatedStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorComplianceText(work.additionalInfo.updatedStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                ], 2)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("div", _hoisted_198, [
                _cache[167] || (_cache[167] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                  _createElementVNode("h1", null, "Task Details")
                ], -1)),
                (_ctx.tabDataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                      _createElementVNode("div", _hoisted_200, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_201, [
                      _createElementVNode("div", null, [
                        _cache[153] || (_cache[153] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                        (_ctx.TaskDetailsDropDown.taskStatus == 10418)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_202, _cache[152] || (_cache[152] = [
                              _createElementVNode("div", { class: "bg-error textColorWhite" }, _toDisplayString('Terminated'), -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_203, [
                              _createVNode(_component_Select, {
                                modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                options: _ctx.taskStatusData,
                                appendTo: "body",
                                onChange: _ctx.onTaskStatusChange,
                                optionLabel: "status",
                                optionValue: "id",
                                class: _normalizeClass(["w-full statusBorder mt-2", _ctx.changeBackground()]),
                                disabled: (_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417),
                                optionDisabled: (option) =>
                                        (option.id === 10403 || option.id === 10417) &&
                                        _ctx.teamReviewerValue !== _ctx.userInfo._id &&
                                        option.id !== _ctx.TaskDetailsDropDown.taskStatus
                              }, null, 8, ["modelValue", "options", "onChange", "class", "disabled", "optionDisabled"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_204, [
                        _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Assignee", -1)),
                        (_ctx.newTeamLeader=='')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_205, "N/A"))
                          : _createCommentVNode("", true),
                        (_ctx.newTeamLeader.value != _ctx.userInfo._id  && _ctx.presentTaskObject.teamOwner != _ctx.userInfo._id || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.TaskDetailsDropDown.taskStatus == 10418)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                              _createElementVNode("p", _hoisted_207, _toDisplayString(_ctx.newTeamLeader.label), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_208, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.presentComplianceObject.teamLeader,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.presentComplianceObject.teamLeader) = $event)),
                                suggestions: _ctx.TeamOwnerOptions,
                                onComplete: _ctx.asyncFind1,
                                onItemSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateTaskForTeamLeader(_ctx.presentComplianceObject.teamLeader))),
                                optionLabel: "label",
                                optionValue: "value",
                                forceSelection: true,
                                placeholder: "TeamLeader",
                                class: "p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"
                              }, null, 8, ["modelValue", "suggestions", "onComplete"])
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_209, [
                        _cache[155] || (_cache[155] = _createElementVNode("label", { class: "controllabel" }, "Reviewer", -1)),
                        _cache[156] || (_cache[156] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.reviewer != undefined || _ctx.presentTaskObject.reviewer != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_210, _toDisplayString(_ctx.getPersonName(_ctx.presentTaskObject.reviewer)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_211, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_212, [
                        _cache[157] || (_cache[157] = _createElementVNode("label", { class: "controllabel" }, "Team Representative", -1)),
                        _cache[158] || (_cache[158] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.teamOwner != undefined || _ctx.presentTaskObject.teamOwner != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_213, _toDisplayString(_ctx.getPersonName(_ctx.presentTaskObject.teamOwner)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_214, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_215, [
                        _cache[159] || (_cache[159] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                        _cache[160] || (_cache[160] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.department != undefined || _ctx.presentTaskObject.department != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_216, _toDisplayString(_ctx.getTeamName(_ctx.presentTaskObject.department)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_217, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_218, [
                        _cache[161] || (_cache[161] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                        _cache[162] || (_cache[162] = _createElementVNode("br", null, null, -1)),
                        (Object.keys(_ctx.presentTaskObject).includes('location') && (_ctx.presentTaskObject.location!=undefined || _ctx.presentTaskObject.location!=null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_219, _toDisplayString(_ctx.presentTaskObject.location), 1))
                          : (Object.keys(_ctx.presentTaskObject).includes('location') && !Object.keys(_ctx.presentTaskObject).includes('entity') && _ctx.presentTaskObject.location != '' && _ctx.presentTaskObject.location != null && _ctx.presentTaskObject.location != undefined)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_220, _toDisplayString(_ctx.presentTaskObject.location), 1))
                            : (Object.keys(_ctx.presentTaskObject).includes('entity') && _ctx.presentTaskObject.entity != '' && _ctx.presentTaskObject.entity != null && _ctx.presentTaskObject.entity != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_221, _toDisplayString(_ctx.getEntity(_ctx.presentTaskObject.entity)), 1))
                              : (Object.keys(_ctx.presentTaskObject).includes('location') && (_ctx.presentTaskObject.location=='' || _ctx.presentTaskObject.location==null)&& _ctx.presentTaskObject.department!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_222, _toDisplayString(_ctx.getLocationNameForSystem(_ctx.presentTaskObject.department)), 1))
                                : ((_ctx.presentTaskObject.entity ==""||_ctx.presentTaskObject.entity !=null) && _ctx.presentTaskObject.location!=null )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (val) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: val._id
                                        }, [
                                          (val._id==_ctx.presentTaskObject.department && val.entityType==20301)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString('Global')))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_225, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_226, [
                        _cache[163] || (_cache[163] = _createElementVNode("label", { class: "controllabel mb-2" }, "Tier", -1)),
                        _cache[164] || (_cache[164] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", null, _toDisplayString(_ctx.getTargetDetails(_ctx.presentTaskObject).tier), 1)
                      ]),
                      _createElementVNode("div", _hoisted_227, [
                        _cache[165] || (_cache[165] = _createElementVNode("label", { class: "controllabel mb-2" }, "Scope", -1)),
                        _cache[166] || (_cache[166] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentTaskObject.tierTitle != '' && _ctx.presentTaskObject.tierTitle != null && _ctx.presentTaskObject.tierTitle != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_228, _toDisplayString(_ctx.presentTaskObject.tierTitle), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_229, "N/A"))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_230, [
              _cache[169] || (_cache[169] = _createElementVNode("h1", null, "Findings", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _cache[168] || (_cache[168] = [
                _createElementVNode("img", {
                  src: _imports_6,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_231, [
              _createElementVNode("div", _hoisted_232, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_233, [
                    _createElementVNode("div", _hoisted_234, [
                      _createElementVNode("div", _hoisted_235, [
                        _createElementVNode("div", _hoisted_236, [
                          _createElementVNode("div", _hoisted_237, [
                            _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel" }, "Finding Id", -1)),
                            _createElementVNode("div", _hoisted_238, _toDisplayString(_ctx.findingsObject.findingId?.toUpperCase()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_239, [
                            _cache[171] || (_cache[171] = _createElementVNode("label", { class: "controllabel" }, "Evidence", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.findingsObject.findingEvidence,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.findingsObject.findingEvidence) = $event)),
                              suggestions: _ctx.filteredOptions,
                              onComplete: _ctx.asyncFind,
                              placeholder: 'Evidences',
                              class: _normalizeClass(["p-inputtext-sm systemsstyling custom-multiselect userSelect mt-2",  {'p-invalid': _ctx.v$.findingsObject.findingEvidence.$error }])
                            }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                            (_ctx.v$.findingsObject.findingEvidence.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                                  (_ctx.v$.findingsObject.findingEvidence.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_241, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_242, [
                        _createElementVNode("div", _hoisted_243, [
                          _cache[172] || (_cache[172] = _createElementVNode("label", { class: "controllabel" }, "Related To", -1)),
                          _createVNode(_component_Select, {
                            modelValue: _ctx.findingsObject.findingRelatedTo,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.findingsObject.findingRelatedTo) = $event)),
                            options: _ctx.findingRelatedToOptions,
                            optionLabel: "label",
                            optionValue: "value",
                            placeholder: "Please select one",
                            appendTo: "self",
                            class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.findingsObject.findingRelatedTo.$error }]),
                            onChange: _ctx.onFindingRelatedToChange
                          }, null, 8, ["modelValue", "options", "class", "onChange"]),
                          (_ctx.v$.findingsObject.findingRelatedTo.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                (_ctx.v$.findingsObject.findingRelatedTo.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_245, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (Number(_ctx.findingsObject.findingRelatedTo) === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                              _cache[173] || (_cache[173] = _createElementVNode("label", { class: "controllabel" }, "Control", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.findingsObject.control_id,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.findingsObject.control_id) = $event)),
                                options: _ctx.taskMappedControlOptions,
                                optionLabel: "label",
                                optionValue: "_id",
                                placeholder: "No control mapped to this task",
                                appendTo: "self",
                                class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.findingsObject.control_id.$error }]),
                                disabled: _ctx.taskMappedControlOptions.length <= 1
                              }, null, 8, ["modelValue", "options", "class", "disabled"]),
                              (_ctx.v$.findingsObject.control_id.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                    (_ctx.v$.findingsObject.control_id.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_248, "No control mapped to this task"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (Number(_ctx.findingsObject.findingRelatedTo) === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                _cache[174] || (_cache[174] = _createElementVNode("label", { class: "controllabel" }, "KPI", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.findingsObject.kpi_id,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.findingsObject.kpi_id) = $event)),
                                  options: _ctx.presentTaskObject.kpis || [],
                                  optionLabel: "description",
                                  optionValue: "_id",
                                  placeholder: "Please select one",
                                  appendTo: "self",
                                  class: _normalizeClass(["w-full mt-2 kpi-title-select", { 'is-invalid': _ctx.v$.findingsObject.kpi_id.$error }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.findingsObject.kpi_id.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                                      (_ctx.v$.findingsObject.kpi_id.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_251, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_252, [
                        _cache[175] || (_cache[175] = _createElementVNode("label", { class: "controllabel" }, "Finding", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.findingsObject.finding) = $event)),
                          class: _normalizeClass(["inputboxstyling mt-2 resize-none", { 'is-invalid': _ctx.v$.findingsObject.finding.$error }]),
                          placeholder: "Finding",
                          rows: "3",
                          onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.findingsObject.finding.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.findingsObject.finding,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.findingsObject.finding.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                              (_ctx.v$.findingsObject.finding.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_254, "Required"))
                                : (_ctx.v$.findingsObject.finding.required && _ctx.v$.findingsObject.finding.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_255, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[176] || (_cache[176] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_256, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.findingsObject) !== JSON.stringify(_ctx.findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onCancelbtn()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.findingsObject) !== JSON.stringify(_ctx.findingsObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForFinding,
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addFindingButton()))
                  }, "Save", 10, _hoisted_257)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUpForResult)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.showPopUpForResult
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_258, [
              _cache[178] || (_cache[178] = _createElementVNode("h1", null, "Result", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onCancelButtonAddPopUpForResult()))
              }, _cache[177] || (_cache[177] = [
                _createElementVNode("img", {
                  src: _imports_6,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_259, [
              _createElementVNode("div", _hoisted_260, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_261, [
                    _createElementVNode("div", _hoisted_262, [
                      _createElementVNode("div", _hoisted_263, [
                        _createElementVNode("div", _hoisted_264, [
                          _createElementVNode("div", _hoisted_265, [
                            _cache[179] || (_cache[179] = _createElementVNode("label", { class: "controllabel" }, "Population", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handlePopulationDecimalValue && _ctx.handlePopulationDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.resultObject.totalPopulation) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation }]),
                              placeholder: "Total Population",
                              onKeyup: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isTotalPopulationValid()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.resultObject.totalPopulation,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            ((_ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                                  (_ctx.v$.resultObject.totalPopulation.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_267, "Required"))
                                    : (!_ctx.resultOfPopulation && !_ctx.v$.resultObject.totalPopulation.required.$invalid )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_268, "Population must be greater than or equal to Compliant"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_269, [
                            _cache[180] || (_cache[180] = _createElementVNode("label", { class: "controllabel" }, "Complaint", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleComplaintDecimalValue && _ctx.handleComplaintDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.resultObject.actualOutput) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.actualOutput.$error, 'disiableState': !_ctx.isCompliantInputEnabled }]),
                              placeholder: "Actual output",
                              disabled: !_ctx.isCompliantInputEnabled
                            }, null, 42, _hoisted_270), [
                              [
                                _vModelText,
                                _ctx.resultObject.actualOutput,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.actualOutput.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                  (_ctx.v$.resultObject.actualOutput.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_272, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_273, [
                        _createElementVNode("div", _hoisted_274, [
                          _createElementVNode("div", _hoisted_275, [
                            _cache[181] || (_cache[181] = _createElementVNode("label", { class: "controllabel" }, "Risk Severity", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.riskSeverity,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.resultObject.riskSeverity) = $event)),
                              options: _ctx.dbSeverity,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "self",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.riskSeverity.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.riskSeverity.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                                  (_ctx.v$.resultObject.riskSeverity.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_277, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_278, [
                        _cache[182] || (_cache[182] = _createElementVNode("label", { class: "controllabel" }, "Comments", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.resultObject.comments) = $event)),
                          class: _normalizeClass(["inputboxstyling resize-none mt-2", { 'is-invalid': _ctx.v$.resultObject.comments.$error }]),
                          placeholder: "Comments",
                          rows: "3",
                          onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.v$.resultObject.comments.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.resultObject.comments,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.resultObject.comments.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_279, [
                              (_ctx.v$.resultObject.comments.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_280, "Required"))
                                : (_ctx.v$.resultObject.comments.required && _ctx.v$.resultObject.comments.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_281, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[183] || (_cache[183] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_282, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCancelbtnForResult()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForResult,
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.addResultButtonForTask(_ctx.resultObject)))
                  }, "Save", 10, _hoisted_283)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUpForKpi)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.showPopUpForKpi
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_284, [
              _cache[185] || (_cache[185] = _createElementVNode("h1", null, "Result", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onCancelButtonAddPopUpForKpi()))
              }, _cache[184] || (_cache[184] = [
                _createElementVNode("img", {
                  src: _imports_6,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_285, [
              _createElementVNode("div", _hoisted_286, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_287, [
                    _createElementVNode("div", _hoisted_288, [
                      _createElementVNode("div", _hoisted_289, [
                        _createElementVNode("div", _hoisted_290, [
                          _createElementVNode("div", _hoisted_291, [
                            (_ctx.presentTaskObject.kpis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                  _cache[186] || (_cache[186] = _createElementVNode("label", { class: "controllabel" }, "KPI Title.", -1)),
                                  _createVNode(_component_Select, {
                                    modelValue: _ctx.resultObject.controlorKpi,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.resultObject.controlorKpi) = $event)),
                                    options: _ctx.kpisArray,
                                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.getKpis())),
                                    optionLabel: "description",
                                    optionValue: "_id",
                                    placeholder: "Please select one",
                                    appendTo: "self",
                                    class: _normalizeClass(["w-full mt-2 kpi-title-select", { 'is-invalid': _ctx.v$.resultObject.controlorKpi.$error }])
                                  }, null, 8, ["modelValue", "options", "class"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.v$.resultObject.controlorKpi.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                                  (_ctx.v$.resultObject.controlorKpi.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_294, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_295, [
                        _createElementVNode("div", _hoisted_296, [
                          _createElementVNode("div", _hoisted_297, [
                            _cache[187] || (_cache[187] = _createElementVNode("label", { class: "controllabel" }, "Complaint", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.handleComplaintDecimalValue && _ctx.handleComplaintDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.resultObject.actualOutput) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.actualOutput.$error }]),
                              placeholder: "Actual output"
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.resultObject.actualOutput,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.actualOutput.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                                  (_ctx.v$.resultObject.actualOutput.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_299, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_300, [
                            _cache[188] || (_cache[188] = _createElementVNode("label", { class: "controllabel" }, "Population", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              onInput: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.handlePopulationDecimalValue && _ctx.handlePopulationDecimalValue(...args))),
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.resultObject.totalPopulation) = $event)),
                              class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation }]),
                              placeholder: "Total Population",
                              onKeyup: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isTotalPopulationValid()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.resultObject.totalPopulation,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.resultObject.totalPopulation.$error || !_ctx.resultOfPopulation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_301, [
                                  (_ctx.v$.resultObject.totalPopulation.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_302, "Required"))
                                    : (!_ctx.resultOfPopulation && !_ctx.v$.resultObject.totalPopulation.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_303, "Population must be greater than or equal to Compliant"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_304, [
                        _createElementVNode("div", _hoisted_305, [
                          _createElementVNode("div", _hoisted_306, [
                            _cache[189] || (_cache[189] = _createElementVNode("label", { class: "controllabel" }, "Risk Severity", -1)),
                            _createVNode(_component_Select, {
                              modelValue: _ctx.resultObject.riskSeverity,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.resultObject.riskSeverity) = $event)),
                              options: _ctx.dbSeverity,
                              optionLabel: "key",
                              optionValue: "value",
                              placeholder: "Please select one",
                              appendTo: "self",
                              class: _normalizeClass(["w-full mt-2", { 'is-invalid': _ctx.v$.resultObject.riskSeverity.$error }])
                            }, null, 8, ["modelValue", "options", "class"]),
                            (_ctx.v$.resultObject.riskSeverity.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_307, [
                                  (_ctx.v$.resultObject.riskSeverity.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_308, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_309, [
                        _cache[190] || (_cache[190] = _createElementVNode("label", { class: "controllabel" }, "Comments", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.resultObject.comments) = $event)),
                          class: _normalizeClass(["inputboxstyling resize-none mt-2", { 'is-invalid': _ctx.v$.resultObject.comments.$error }]),
                          placeholder: "Comments",
                          rows: "3",
                          onInput: _cache[44] || (_cache[44] = ($event: any) => (_ctx.v$.resultObject.comments.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.resultObject.comments,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.resultObject.comments.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_310, [
                              (_ctx.v$.resultObject.comments.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_311, "Required"))
                                : (_ctx.v$.resultObject.comments.required && _ctx.v$.resultObject.comments.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_312, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[191] || (_cache[191] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_313, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onCancelbtnForResult()))
                  }, "Reset", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["", JSON.stringify(_ctx.resultObject) !== JSON.stringify(_ctx.resultObjectDummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    disabled: _ctx.clickOnButtonForResult,
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.addResultButtonForTaskKpi(_ctx.resultObject)))
                  }, "Save", 10, _hoisted_314)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 5,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_315, [
              _createElementVNode("div", _hoisted_316, [
                _createElementVNode("div", _hoisted_317, [
                  _createElementVNode("div", _hoisted_318, [
                    _cache[193] || (_cache[193] = _createElementVNode("h1", null, "Import files", -1)),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onCancelIcon()))
                    }, _cache[192] || (_cache[192] = [
                      _createElementVNode("img", {
                        src: _imports_6,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[198] || (_cache[198] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_319, [
                    _createElementVNode("div", _hoisted_320, [
                      _createElementVNode("div", _hoisted_321, [
                        _createElementVNode("div", _hoisted_322, [
                          _createElementVNode("div", _hoisted_323, [
                            _createElementVNode("div", null, [
                              _cache[194] || (_cache[194] = _createElementVNode("label", { class: "controllabel" }, "File Name ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                                type: "text",
                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                placeholder: "Filename",
                                onInput: _cache[49] || (_cache[49] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.inputFileName,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.inputFileName.$error )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_324, [
                                    (_ctx.v$.inputFileName.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_325, "Required"))
                                      : (_ctx.v$.inputFileName.required && _ctx.v$.inputFileName.restrictCharacters50.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_326, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_327, [
                              _cache[196] || (_cache[196] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "fileInput",
                                class: "hidden",
                                id: "upload",
                                onChange: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                              }, null, 544),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2", {'is-invalid':_ctx.v$.fileToUpload.$error || _ctx.pdfValidation}])
                              }, [
                                _createElementVNode("label", _hoisted_328, [
                                  _cache[195] || (_cache[195] = _createElementVNode("div", { class: "float-right text-white flex justify-center heightForDiv items-center w-9 bg-primary" }, [
                                    _createElementVNode("img", { src: _imports_7 })
                                  ], -1)),
                                  (_ctx.fileName == '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_329, _toDisplayString(_ctx.placeholder), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.fileName != '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_330, _toDisplayString(_ctx.fileName), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2)
                            ]),
                            (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_331, [
                                  (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_332, "File upload is required"))
                                    : _createCommentVNode("", true),
                                  (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_333, "Upload only pdf"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[197] || (_cache[197] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_334, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", (_ctx.inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                          onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                          disabled: _ctx.clickOnButton
                        }, "Save", 10, _hoisted_335)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteEvidenceConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_336, [
          _createElementVNode("div", {
            class: "evidence-delete-backdrop",
            onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
          }),
          _createElementVNode("div", _hoisted_337, [
            _cache[199] || (_cache[199] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
              _createElementVNode("div", { class: "evidence-delete-warning" }, [
                _createElementVNode("img", {
                  src: _imports_8,
                  class: "evidence-delete-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Delete Evidence")
            ], -1)),
            _cache[200] || (_cache[200] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
            _createElementVNode("div", _hoisted_338, [
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-cancel",
                onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-ok",
                onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
              }, "OK")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkEvidencePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_339, [
          _createElementVNode("div", {
            class: "link-existing-backdrop",
            onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
          }),
          _createElementVNode("div", _hoisted_340, [
            _cache[210] || (_cache[210] = _createElementVNode("div", { class: "link-existing-title" }, [
              _createElementVNode("span", {
                class: "link-existing-warning",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_8,
                  class: "link-existing-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Link Existing Evidence")
            ], -1)),
            _cache[211] || (_cache[211] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
            _createElementVNode("div", _hoisted_341, [
              _createElementVNode("div", _hoisted_342, [
                _createElementVNode("div", _hoisted_343, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "filterButton flex",
                  onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                }, _cache[201] || (_cache[201] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ")
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
              }, [
                _createElementVNode("table", _hoisted_344, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[206] || (_cache[206] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                      }, [
                        _createElementVNode("div", _hoisted_345, [
                          _cache[202] || (_cache[202] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                      }, [
                        _createElementVNode("div", _hoisted_346, [
                          _cache[203] || (_cache[203] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                      }, [
                        _createElementVNode("div", _hoisted_347, [
                          _cache[204] || (_cache[204] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                      }, [
                        _createElementVNode("div", _hoisted_348, [
                          _cache[205] || (_cache[205] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ])
                    ]),
                    (_ctx.showExistingEvidenceFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_349, [
                          _cache[207] || (_cache[207] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                              placeholder: "Search",
                              onClick: _cache[62] || (_cache[62] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.filename,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                              placeholder: "Search",
                              onClick: _cache[64] || (_cache[64] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.sourceTaskId,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                              placeholder: "Search",
                              onClick: _cache[66] || (_cache[66] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.evidenceType,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _cache[208] || (_cache[208] = _createElementVNode("td", null, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.filteredSortedExistingEvidences.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_350, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.optionKey
                          }, [
                            _createElementVNode("td", _hoisted_351, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.isExistingEvidenceSelected(row),
                                onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                              }, null, 40, _hoisted_352)
                            ]),
                            _createElementVNode("td", {
                              title: row.filename
                            }, _toDisplayString(row.filename), 9, _hoisted_353),
                            _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.existingEvidenceTypeLabel(row)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_354, _cache[209] || (_cache[209] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: "link-existing-empty",
                            colspan: "5"
                          }, "No Records Found")
                        ], -1)
                      ])))
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_355, [
              _createElementVNode("button", {
                type: "button",
                class: "link-existing-cancel",
                onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
              }, "Save", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}